<template>
	<div class="loading-overlay">
		<div class="spinner"></div>
	</div>
</template>

<style scoped>
	.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(255, 255, 255, 0.8); /* Sayfanın üzerini beyaz yarı şeffaf bir renk ile kaplar */
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 10000; /* Diğer tüm öğelerin üzerinde olacak şekilde */
	}

	.spinner {
		border: 3px solid rgba(0, 0, 0, 0.1);
		border-top: 3px solid var(--logo-color);
		border-radius: 50%;
		width: 60px;    
		height: 60px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
	</style>

